{
  "common": {
    "unassigned": "Unassigned",
    "notAvailable": "N/A",
    "untitled": "(Untitled)",
    "guest": "Guest",
    "taskFallback": "Task",
    "team": "team",
    "currentTime": "Current time"
  },
  "actions": {
    "save": "save",
    "cancel": "cancel",
    "delete": "delete",
    "previous": "previous",
    "next": "next",
    "send": "Send",
    "create": "Create"
  },
  "tabs": {
    "lista": "list",
    "tablero": "board",
    "flow": "flow",
    "today": "Today",
    "week": "Wk",
    "month": "Mo",
    "threeMonths": "3M",
    "oneYear": "1Y",
    "custom": "Custom"
  },
  "stages": {
    "planeada": "planned",
    "en proceso": "in progress",
    "synk": "synk",
    "check": "check",
    "retraso": "delayed",
    "bloqueo": "blocked",
    "done": "done"
  },
  "priority": {
    "baja": "low",
    "media": "medium",
    "alta": "high"
  },
  "list": {
    "hideCompleted": "Hide completed",
    "showCompleted": "Show completed"
  },
  "filter": {
    "savedAll": "Filter saved: All",
    "savedCount": "Filter saved: {{count}} user(s)"
  },
  "toolbar": {
    "searchPlaceholder": "search...",
    "searchAriaLabel": "Search tasks",
    "createButton": "Create",
    "periodPrevious": "Previous period",
    "periodNext": "Next period"
  },
  "table": {
    "headers": {
      "stage": "stage",
      "title": "task title",
      "date": "date",
      "time": "time",
      "priority": "priority",
      "assignee": "assignee",
      "supervisor": "supervisor"
    },
    "markComplete": "Mark \"{{title}}\" as completed",
    "stageOf": "Stage of \"{{title}}\"",
    "priorityOf": "Priority of \"{{title}}\"",
    "recurrentTooltip": "Recurs every {{interval}} {{unit}}",
    "moreOptions": "More options",
    "deleteConfirmTitle": "Delete task?",
    "pagination": {
      "previous": "previous",
      "next": "next",
      "indicator": "page {{current}} of {{total}}"
    }
  },
  "kanban": {
    "dropHere": "drop tasks here",
    "dateTag": {
      "today": "today",
      "oneDayAgo": "1 day ago",
      "daysAgo": "{{count}} days ago",
      "oneWeekAgo": "a week ago",
      "twoWeeksAgo": "two weeks ago",
      "moreThanThreeWeeksAgo": "more than 3 wks ago",
      "inOneDay": "in 1 day",
      "inDays": "in {{count}} days",
      "inOneWeek": "in a week",
      "inTwoWeeks": "in two weeks"
    }
  },
  "flow": {
    "searchPlaceholder": "search roadmap...",
    "searchAriaLabel": "Search the roadmap",
    "noTasks": "No tasks",
    "noStage": "No stage",
    "untitledNode": "Untitled",
    "weekLabel": "Week {{number}}"
  },
  "empty": {
    "loadingTasks": "Loading tasks from the relational server...",
    "loadingTimeline": "loading timeline...",
    "noResults": "no results"
  },
  "duration": {
    "amountAria": "Amount of time",
    "unitAria": "Time unit",
    "units": {
      "minutos": "minutes",
      "horas": "hours",
      "días": "days",
      "semanas": "weeks"
    }
  },
  "userSelect": {
    "searchAria": "Search user",
    "searchPlaceholder": "search..."
  },
  "modal": {
    "close": "Close",
    "titleAriaLabel": "Task title",
    "titlePlaceholder": "New Task",
    "stageLabel": "stage:",
    "stageAriaLabel": "Task stage",
    "assigneeLabel": "assignee:",
    "supervisorLabel": "supervisor:",
    "dateLabel": "date:",
    "timeLabel": "time:",
    "tagsLabel": "tags:",
    "addTagPlaceholder": "+",
    "addTagAriaLabel": "Add tag",
    "removeTagAriaLabel": "Remove tag {{tag}}",
    "recurrenceLabel": "recurring:",
    "recurrenceEvery": "every {{interval}} {{unit}}",
    "recurrenceNone": "no",
    "recurrencePopoverTitle": "Configure Recurrence",
    "recurrenceEveryLabel": "every",
    "recurrenceIntervalAria": "Recurrence interval",
    "recurrenceUnitAria": "Recurrence unit",
    "recurrenceUnits": {
      "dias": "days",
      "weeks": "weeks",
      "meses": "months",
      "años": "years"
    },
    "save": "Save",
    "findNextSlot": "Find next available time slot",
    "deleteTask": "Delete task",
    "deleteConfirm": "Are you sure you want to delete this task?",
    "descriptionAriaLabel": "Task description",
    "descriptionPlaceholder": "Add a tasteful, subtle description...",
    "nextTasks": "next tasks",
    "subtaskBackAria": "Go back to previous step",
    "subtaskAssistantAria": "Subtask creation assistant",
    "subtaskTitleRequired": "Title is required",
    "subtaskPlaceholders": {
      "title": "Type a task and press Enter...",
      "description": "Description.. enter..",
      "assignee": "Assign to someone (e.g. beeto) and press Enter...",
      "duration": "Pick the duration in minutes (e.g. 15, 30, 60) and press Enter...",
      "supervisor": "Assign a supervisor (optional) and press Enter..."
    },
    "startTime": "start time",
    "monthPrev": "Previous month",
    "monthNext": "Next month",
    "reminderDateRequired": "Pick a date",
    "reminderUsersRequired": "Pick at least one user",
    "monthNames": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    "monthNamesShort": ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    "weekDaysShort": ["mo", "tu", "we", "th", "fr", "sa", "su"],
    "share": "Share",
    "shareAriaLabel": "Share task",
    "shareTitle": "Share task",
    "shareLinkAriaLabel": "Link to share",
    "shareCopy": "Copy",
    "shareCopied": "Copied!",
    "shareWhatsapp": "WhatsApp",
    "shareTelegram": "Telegram",
    "shareEmail": "Email",
    "shareEmailSubject": "I'm sharing a task with you on Colonny",
    "shareMessage": "I'm sharing this task with you on Colonny: {{title}}",
    "standaloneForbiddenTitle": "You don't have access to this task",
    "standaloneForbiddenBody": "You need to belong to the \"{{spaceName}}\" space to view this task.",
    "standaloneNotFoundTitle": "We couldn't find this task",
    "standaloneNotFoundBody": "It may no longer exist, or the link may be incorrect.",
    "backToHome": "Back to home"
  },
  "smartTags": {
    "priorityHigh": "High Priority",
    "bugReport": "Bug Report",
    "reviewNeeded": "Review Needed",
    "meeting": "Meeting 📅",
    "reminder": "Reminder ⏰",
    "documentation": "Documentation 📄",
    "presentations": "Presentations 📐",
    "survey": "Survey 🙋",
    "flow": "Flow 🗡️"
  },
  "comments": {
    "tabs": {
      "info": "Info",
      "comentarios": "comments",
      "team": "team",
      "docs": "docs",
      "meets": "meets"
    },
    "noTeamMembers": "No team members in this conversation yet...",
    "noDocs": "No files or documents...",
    "noMeets": "No meetings scheduled...",
    "startConversation": "Start the conversation...",
    "deleteConfirm": "Are you sure you want to delete this comment?",
    "editAria": "Edit comment",
    "saveAria": "Save comment",
    "cancelEditAria": "Cancel edit",
    "deleteAria": "Delete comment",
    "delete": "Delete",
    "likeAria": "Like",
    "unlikeAria": "Unlike",
    "addReminderTitle": "Add a reminder to this comment",
    "reminderTitle": "Reminder",
    "reminderCopyTitle": "Click to copy the link",
    "reminderDetailsTitle": "Reminder Details",
    "reminderCalendar": "Calendar:",
    "reminderDate": "Date:",
    "reminderCopyHint": "Click the icon to copy the link",
    "reminderUnknownCalendar": "Unknown",
    "reminderSavedBadge": "Reminder saved",
    "reminderDefaultTitle": "Comment reminder",
    "reminderEventDescription": "Reminder from the task comments: {{title}}.",
    "searchUserPlaceholder": "search user...",
    "searchUserAria": "Search user for the reminder",
    "save": "save",
    "writePlaceholder": "Write a comment or @mention... drag a file in.",
    "suggestionPlaceholder": "Write a suggestion or reminder for this update...",
    "suggestionBadge": "Suggestion",
    "linkedTaskBadge": "Linked task",
    "suggestionModeBanner": "Suggestion / structured improvement mode",
    "suggestionModeExit": "Back to a normal comment",
    "attachFile": "Attach file",
    "recordScreen": "Record screen",
    "send": "Send",
    "expandImage": "Expand image",
    "formatToolbarAria": "Formatting toolbar",
    "headingAria": "Heading type",
    "headingParagraph": "Paragraph",
    "bold": "Bold",
    "italic": "Italic",
    "link": "Link",
    "linkPrompt": "Paste a link",
    "linkApply": "Apply",
    "bulletList": "Bullet list",
    "orderedList": "Numbered list",
    "checklist": "Checklist",
    "quote": "Quote",
    "codeBlock": "Code block",
    "expandEditor": "Expand to full screen",
    "collapseEditor": "Back to panel",
    "workspaceTitle": "Comment",
    "authorUnavailable": "Author unavailable",
    "creatorAction": "created this task",
    "titleChangeAction": "changed the title: {{oldValue}} ➔ {{newValue}}",
    "descriptionChangeAction": "changed the task description",
    "statusChangeAction": "changed status: {{oldValue}} ➔ {{newValue}}"
  },
  "image": {
    "closeAria": "Close image",
    "expandedAlt": "Enlarged view"
  },
  "errors": {
    "fileUploadFailed": "Error uploading file",
    "createTaskFailed": "Could not create the task",
    "oldReminderNoEvent": "This is an old reminder or has no associated event.",
    "linkCopied": "Event link copied to clipboard.",
    "copyFailed": "Could not copy the link. URL: {{url}}",
    "eventUrlFallback": "Event URL: {{url}}"
  },
  "sidebar": {
    "title": "tasks",
    "projectFallback": "Project",
    "newProjectPlaceholder": "Project name...",
    "createNew": "create new",
    "filterSearchPlaceholder": "Search user to filter...",
    "clearSelection": "Clear selection",
    "selectAll": "Select all",
    "tasksNav": "Tasks",
    "reportsSeparator": "reports",
    "reporting": "reporting",
    "hitosSeparator": "milestones",
    "hitoTitlePlaceholder": "Milestone title...",
    "hitoDescPlaceholder": "Description (optional)...",
    "loadingHitos": "Loading milestones...",
    "noHitos": "No active milestones",
    "newHito": "new milestone",
    "addHitoAria": "Add milestone"
  },
  "workframe": {
    "index": {
      "title": "INDEX",
      "searchPlaceholder": "Search the index...",
      "expandAll": "Expand all documents and subdocuments",
      "collapseAll": "Collapse the whole index",
      "loading": "Loading index...",
      "empty": "No documents under this structure.",
      "createFirst": "Create first document",
      "noMatches": "No matches found for \"{{term}}\"",
      "addSubdoc": "Add subdocument",
      "subdocPlaceholder": "Subdocument title...",
      "create": "Create",
      "newDocDefault": "New document",
      "untitled": "Untitled",
      "noSpace": "No space",
      "resizeHandle": "Drag to resize the index",
      "positionUpdated": "Position updated",
      "positionUpdateFailed": "Could not update the position",
      "widthSaved": "Index width saved"
    },
    "doc": {
      "title": "DOCUMENTATION",
      "collapse": "Collapse documentation column",
      "expand": "Expand documentation column",
      "changeIcon": "Change document icon",
      "titlePlaceholder": "Document title...",
      "loading": "Loading document...",
      "placeholder": "Select a document from the index to view and edit its documentation",
      "iconUpdated": "Icon updated",
      "iconUpdateFailed": "Failed to update the icon",
      "titleSaved": "Title saved",
      "titleSaveFailed": "Failed to save the title",
      "textSaved": "Text saved",
      "textSaveFailed": "Failed to save the text",
      "collapsed": "Documentation collapsed",
      "expanded": "Documentation expanded"
    },
    "bitacora": {
      "title": "LOG",
      "addUpdate": "Add update",
      "loading": "Loading log...",
      "empty": "No updates recorded yet.",
      "addFirst": "Add first update",
      "untitledUpdate": "Untitled update",
      "docBadge": "Document: {{title}}",
      "noTime": "No time",
      "addSuggestion": "Add suggestion / structured improvement",
      "suggestionFallback": "Suggestion",
      "suggestionBy": "Suggestion by {{name}}: {{snippet}}",
      "user": "User"
    },
    "dropdown": {
      "tooltip": "Workframes",
      "title": "Workframes",
      "none": "None",
      "structurePrefix": "STRUCTURE:",
      "loading": "Loading...",
      "updatesStructure": "Updates structure",
      "workframe": "Workframe",
      "linkToDoc": "Link to document:",
      "docSearchPlaceholder": "Type the document title...",
      "loadingDocs": "Loading documents...",
      "noDocs": "No documents found",
      "createFailed": "Could not create the workframe"
    },
    "share": {
      "title": "Share structured document",
      "close": "Close",
      "noAccess": "No access to the document",
      "linkedDocFallback": "Linked document",
      "message": "You mentioned @{{name}} in this structured task. They don't have permission to view the document \"{{title}}\". Do you want to invite them so they can collaborate and see it in their panel?",
      "readOnly": "Read only",
      "editor": "Collaborative editor",
      "skip": "Skip (keep private)",
      "grantFailed": "Could not share the document",
      "granted": "Document shared with @{{name}}"
    }
  }
}
